import { Action } from "../../store/types";
import { ProductLayout } from "../../models";
import * as actions from "./actions";

export interface LayoutChoiceState {
  layouts: ProductLayout[];
  chosenLayout?: ProductLayout;
  isLayoutsLoading: boolean;
}

const initState: LayoutChoiceState = {
  layouts: [],
  chosenLayout: undefined,
  isLayoutsLoading: false,
};

export default function(
  state = initState,
  { type, payload }: Action,
): LayoutChoiceState {
  switch (type) {
    case actions.SET_LAYOUTS:
      return {
        ...state,
        layouts: payload,
        chosenLayout: state.chosenLayout || payload[0],
      }; // Choose first layout as default
    case actions.SET_CHOSEN_LAYOUT:
      return { ...state, chosenLayout: payload };
    case actions.SET_LAYOUTS_LOADING:
      return { ...state, isLayoutsLoading: payload };
    case actions.RESET:
      return initState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/routes/WizardLayoutChoice/reducer.ts